export default {
  buttons: {
    send_code: 'Anmeldecode senden',
  },
  placeholders: {
    mobile_number: 'Handynummer',
  },
  feedback: {
    phone_number_required: 'Bitte gebe deine Telefonnummer ein',
  },
};
